import { useState } from 'react'

import { Box, Form, Text } from '@factorialco/deprecated-design-system'
import { TargetGroupDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  PerformanceProcessTargetTypeFragment,
  PerformanceReviewOverviewHeaderDocument,
  UpdateTargetStrategyPerformanceReviewProcessDocument,
  UpdateTargetStrategyPerformanceReviewProcessMutationVariables,
} from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { TargetGroupSection } from '../../forms/TargetGroup'
import { Variables } from '../../forms/TargetGroup/targetEnums'
import TargetGroupDataTable from './TargetGroupDataTable'

export const TargetGroup: React.FC<{
  review: PerformanceProcessTargetTypeFragment
}> = ({ review }) => {
  const [variables, setVariables] =
    useState<UpdateTargetStrategyPerformanceReviewProcessMutationVariables>({
      id: review.id,
      targetStrategy: review.targetStrategy?.strategy,
      arguments: review.targetStrategy?.arguments,
    })

  const [updateReviewTargetStrategy, { loading }] = useMutation(
    UpdateTargetStrategyPerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.updateTargetStrategyPerformanceReviewProcess,
      refetchQueries: [TargetGroupDataTableDocument, PerformanceReviewOverviewHeaderDocument],
    }
  )

  const handleChange = (data: Variables) => {
    setVariables({
      ...variables,
      ...data,
    })
  }

  const form = useForm<Variables>({
    defaultValues: {
      id: review.id,
      targetStrategy: review.targetStrategy?.strategy,
      arguments: review.targetStrategy?.arguments,
    },
    onSubmit: async (_data) => {
      const response = await updateReviewTargetStrategy({
        variables,
      })

      const result = handleResult(response, () => null)
      if (result.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
      }
      return result
    },
  })

  return (
    <Form padding={null}>
      <Box gap="s32">
        <Box gap="s16">
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.targets')}
          </Text>
          <Text size="300">
            {i18n.t('performance_process.reviews.launch_participation_modal_description')}
          </Text>
        </Box>
        <TargetGroupSection
          variables={variables}
          loading={loading}
          onChange={handleChange}
          onSubmit={form.handleSubmit}
        />
        <Box>
          <Text size="300" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.target_preview')}
          </Text>
          <TargetGroupDataTable reviewId={review.id} />
        </Box>
      </Box>
    </Form>
  )
}
